__turbopack_context__.v({
  "link": "HolderHeadline-module__e6GrYq__link",
  "linkWrapper": "HolderHeadline-module__e6GrYq__linkWrapper",
});
